import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

import vueMiniPlayer from "vue-mini-player";
import "vue-mini-player/lib/vue-mini-player.css";

import VueAliplayerV2 from "vue-aliplayer-v2";
import "@/assets/css/common.scss";

import "vant/lib/index.css";
import axios from "axios";
// 按需引入组件
import { NavBar } from "vant";
import { Button } from "vant";
import { Col, Row } from "vant";
import { Icon } from "vant";
import { Dialog } from "vant";
import { Toast } from "vant";
import { Overlay } from "vant";
import { Swipe, SwipeItem } from "vant";
import { Loading } from "vant";
import { RadioGroup, Radio } from "vant";
import { CountDown } from "vant";

Vue.use(VideoPlayer);
Vue.use(VueAliplayerV2);
// 全局注册
Vue.use(CountDown);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Overlay);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(NavBar);
Vue.use(vueMiniPlayer);
Vue.config.productionTip = false;

new Vue({
  axios,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
